import { PAGE_SIZE } from "../../../../constants/Config";
import {
    DISTRICT_DELETE,
    DISTRICT_DETAIL,
    DISTRICT_INSERT,
    DISTRICT_LIST,
    DISTRICT_UPDATE,
    DISTRICT_GETALL
} from "./action-types";


const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    item: null,
    suggestion: null
}

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case DISTRICT_LIST:
            return list(state, payload)
        case DISTRICT_DETAIL:
            return detail(state, payload)
        case DISTRICT_UPDATE:
            return update(state, payload)
        case DISTRICT_INSERT:
            return insert(state, payload)
        case DISTRICT_DELETE:
            return deletes(state, payload)
        case DISTRICT_GETALL:
            return suggestion(state, payload)
        default:
            return state
    }
}

function list(state, payload) {
    state = Object.assign({}, state, payload)
    return state
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    })
    return state
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.id !== payload)

    return Object.assign({}, state, { data })
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload }
        }
        return obj
    })

    return Object.assign({}, state, { data })
}

function insert(state, payload) {
    const data = [...state.data, payload]
    return Object.assign({}, state, { data })
}

function suggestion(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    })
    return state;
}

export default reducer
